<template>
  <div>
    <table
      class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom"
      v-if="claims && claims.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>
            Date de création
          </th>
          <th v-if="!isPromoteur">
            <span>
              Promoteur
            </span>
          </th>
          <th v-if="isPromoteur">
            <span>
              Société
            </span>
          </th>
          <th v-if="isAdmin || isManager">
            <span>Vendeur</span>
          </th>
          <th>
            <span>Contact</span>
          </th>
          <th>
            <span>Téléphone Contact</span>
          </th>
          <th>
            <span>Ville Contact</span>
          </th>
          <th>
            <span>Email Contact</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(claim) in claims"
          :key="claim.pk"
          class="is-size-6"
          :id="'e' + claim.pk">
          <td class="has-text-centered">
            <span
              class="dot tooltip is-tooltip-right"
              :class="claim.status | dotClass"
              :style="{'background-color': tagColor(claim.status)}"
              :data-tooltip="optionStatus[claim.status].label" />
          </td>
          <td>
            <span>
              {{ claim.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
            </span>
          </td>
          <td
            v-if="!isPromoteur && isPromoteurDetailsActivated(claim)"
            class="is-cell-hoverable is-narrow">
            <router-link
              :to="{name: 'PromoteurPresentation', params: {id: claim.promoteur.pk}}">
              <span class="">{{ claim.promoteur.name }}</span>
            </router-link>
          </td>
          <td v-if="!isPromoteur && !isPromoteurDetailsActivated(claim)">
            {{ claim.promoteur.name }}
          </td>
          <td v-if="isPromoteur">
            {{ claim.user.account.name }}
          </td>
          <td
            v-if="isAdmin || isManager"
            class="is-cell-hoverable">
            <router-link
              :to="{name: 'UserVue', params: {id: claim.user.pk}}"
              class="fullLink">
              {{ claim.user.last_name }} {{ claim.user.first_name }}
            </router-link>
          </td>
          <td
            :class="{'is-cell-hoverable' : claim.contact.account.pk === currentUser.account.pk}">
            <router-link
              v-if="claim.contact.account.pk === currentUser.account.pk"
              :to="{name: 'ContactVue', params: {id: claim.contact.pk}}"
              class="fullLink">
              {{ claim.contact.last_name }} {{ claim.contact.first_name }}
            </router-link>
            <template v-else>
              {{ claim.contact.last_name }} {{ claim.contact.first_name }}
            </template>
          </td>
          <td>
            <phone-number :phone="claim.contact.phone" />
          </td>
          <td>
            <span v-if="claim.contact.address != null">{{ claim.contact.address.city }} ({{ claim.contact.address.zip_code }})</span>
            <span v-else>--</span>
          </td>
          <td>
            <span>{{ claim.contact.email }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucune dénonciation à afficher
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)"></pagination>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import { mapGetters, mapState } from 'vuex'
import randomColor from 'randomcolor'

export default {
  name: 'ClaimLightList',
  filters: {
    dotClass (value) {
      const COLORS = {
        'approved': 'has-background-success',
        'pending': 'has-background-warning',
        'refused': 'has-background-danger'
      }
      return COLORS[value]
    }
  },
  mixins: [DefaultValues],
  props: {
    loading: {
      type: Boolean
    },
    currentPage: {
      type: Number
    },
    totalPage: {
      type: Number
    },
    totalClaim: {
      type: Number
    },
    claims: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      activationStatus: [
        { value: 'approved', label: 'Accepté', color: 'is-success' },
        { value: 'pending', label: 'En attente', color: 'is-warning' }
      ]
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'isSeller']),
    ...mapGetters({ storeAccounts: 'accounts' }),
    currentView () {
      return this.$route.name
    }
  },
  methods: {
    isPromoteurDetailsActivated (option) {
      return this.storeAccounts.find(a => a.name === option.promoteur.name).promoteur_details_activated
    },
    loadItems (event) {
      this.$emit('loadItems', event)
    },
    tagColor (value, hue = 'blue') {
      let color = randomColor({
        seed: value,
        hue
      })
      return color
    }
  }
}
</script>
